<template>
    <div class="step-index">
        <div
            v-for="(item, index) in list"
            :key="index"
            v-bind:class="{'active': active === index + 1}"
            class="step-item">
            <div class="step-circle"></div>
            <div class="step-label">{{item}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StepIndex',
    props: ['list', 'active'],
    methods: {

    }
}
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.step-index {
    display: flex;
    justify-content: space-between;
    padding: .34rem 1.1rem .3rem;
    background: $bg_color_FC;
    .step-item {
        position: relative;
        width: 1rem;
        &::after {
            content: "";
            position: absolute;
            top: .11rem;
            right: -0.6rem;
            width: .6rem;
            border-bottom: .02rem dashed rgba($color: $font_color_51b, $alpha: 0.2);
        }
        & + .step-item {
            &::before {
                content: "";
                position: absolute;
                top: .11rem;
                left: -0.54rem;
                width: .6rem;
                border-bottom: .02rem dashed rgba($color: $font_color_51b, $alpha: 0.2);
            }
        }

        &:last-child {
            &::after {
                display: none;
            }
        }
    }
    .step-circle {
        position: relative;
        width: .24rem;
        height: .24rem;
        margin: 0 auto .1rem;
        border-radius: 50%;
        border: .03rem solid rgba($color: $grey_border_color_cb, $alpha: 0.15);
        background: $white_bg_color;
        &::after {
            position: absolute;
            left: 0.04rem;
            top: 0.04rem;
            content: "";
            width: .1rem;
            height: .1rem;
            border-radius: 50%;
            background: rgba($color: $grey_border_color_cb, $alpha: 0.5);
        }
    }
    .step-label {
        font-size: .14rem;
        color: $font_color_A4;
        text-align: center;
    }
    .step-item.active {
        .step-label {
            color: $font_color;
        }
        .step-circle {
            border-color: rgba($color: $font_color_51b, $alpha: 0.08);
            &::after {
                background: rgba($color: $font_color_51b, $alpha: 0.9);
            }
        }
        &::after {
            border-color: $border_color_8EF;
        }
        &::before {
            border-color: $border_color_8EF;
        }
    }
}
</style>